// Remembers the PIN + app-password an operator last used for a given
// (farm, device, app), so switching the app away and back on THE SAME device
// restores its secrets instead of re-typing them. Keyed by APP within a device —
// the task type (deposit/payout) is NOT part of the key, so both tasks of an app
// share one PIN/password. Client-only convenience for senior_operator+ who can see
// secrets; the authoritative config still lives server-side per device.
//
// Kept in an in-memory Map (NOT persisted) so secrets never touch localStorage, and
// scoped by farmId + udid so every phone keeps its OWN credentials — the same app on
// a sibling device never auto-fills another phone's secret.
const store = new Map();
const comboKey = (farmId, udid, app) => `${farmId}:${udid}:${app}`;
/** Recall the PIN/password last used for this device's app, if any. */
export function recallClickerCreds(farmId, udid, app) {
    if (!app)
        return undefined;
    return store.get(comboKey(farmId, udid, app));
}
/** Remember the PIN/password just saved for this device's app. */
export function rememberClickerCreds(farmId, udid, app, pin, password) {
    if (!app)
        return;
    store.set(comboKey(farmId, udid, app), { pin, password });
}
